module.exports = __webpack_public_path__ + "img/137.b978a4b4.jpg";